import Nullstack from 'nullstack';
export default function IconTex({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tex",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 8v-1h-6v1"
  }), "   ", Nullstack.element("path", {
    d: "M6 15v-8"
  }), "   ", Nullstack.element("path", {
    d: "M21 15l-5 -8"
  }), "   ", Nullstack.element("path", {
    d: "M16 15l5 -8"
  }), "   ", Nullstack.element("path", {
    d: "M14 11h-4v8h4"
  }), "   ", Nullstack.element("path", {
    d: "M10 15h3"
  }), " ");
}